import { motion } from "framer-motion";
import { Phone, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { COMPANY } from "@/data/site";

const BENEFITS = [
  "No minimum order required",
  "Free design consultation",
  "Same-day printing available",
  "UAE-wide delivery",
];
 const phoneNumber = "971562973825";

const defaultMessage =
  "Hello PRINT ZONE! I'd like to get a custom quote for a printing project. Could you please help me with the details and pricing?";
const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(defaultMessage)}`; 
export default function CTASection() {
  return (
    <section data-testid="cta-section" className="relative overflow-hidden bg-[#0F172A] text-white py-24 md:py-32">
      <div className="pz-blob bg-[#2563EB] w-[400px] h-[400px] -top-32 -left-24 opacity-40" />
      <div className="pz-blob bg-[#F59E0B] w-[320px] h-[320px] bottom-[-160px] right-[-80px] opacity-30" />
      <div className="relative pz-container">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-7"
          >
            <span className="pz-overline" style={{ color: "#F59E0B" }}>Let&apos;s build something</span>
            <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-tight">
              Ready to Transform<br />Your Brand?
            </h2>
            <p className="mt-6 text-white/75 text-lg max-w-xl">
              Get a custom quote for your printing needs. Our team is ready to help you create stunning print materials.
            </p>
            <ul className="mt-8 grid sm:grid-cols-2 gap-3">
              {BENEFITS.map((b) => (
                <li key={b} className="flex items-center gap-3 text-white/85 text-sm">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#F59E0B]" /> {b}
                </li>
              ))}
            </ul>
            <div className="mt-10 flex flex-wrap gap-4">
              <a
                href={`tel:${COMPANY.phone.replace(/\s/g, "")}`}
                data-testid="cta-call"
                className="inline-flex items-center gap-2 px-7 py-4 rounded-full pz-btn-outline"
              >
                <Phone className="w-4 h-4" /> Call Now
              </a>
              <Link
                to={whatsappUrl}
                data-testid="cta-quote"
                className="inline-flex items-center gap-2 px-7 py-4 rounded-full pz-btn-gold text-sm"
              >
                Get Quote <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: 0.15 }}
            className="lg:col-span-5"
          >
            <div className="relative pz-glass-dark rounded-3xl p-8">
              <div className="text-[11px] uppercase tracking-[0.22em] text-[#F59E0B] font-semibold">Express Lane</div>
              <div className="mt-3 font-display text-6xl font-bold text-white">48h</div>
              <div className="mt-2 text-white/70">Same-week production across all 7 Emirates.</div>
              <div className="mt-6 h-[1px] bg-white/10" />
              <div className="mt-6 grid grid-cols-2 gap-5">
                {[
                  { v: "5000+", l: "Projects" },
                  { v: "1000+", l: "Happy Clients" },
                  { v: "117+", l: "Products" },
                  { v: "100%", l: "On-time Rate" },
                ].map((s) => (
                  <div key={s.l}>
                    <div className="font-display text-2xl font-bold text-[#F59E0B]">{s.v}</div>
                    <div className="text-white/60 text-xs uppercase tracking-widest mt-1">{s.l}</div>
                  </div>
                ))}
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
